import { Tooltip } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { Icon } from "../../../../components/icons";
import { Flex, Grid } from "../../../../components/layout";
import { colours } from "../../../../styles/colours";
import { SectionTitle } from "../common/components";
import { useNewLaunchContext } from "../context";

const Container = styled(Flex)<{ selected?: boolean }>`
  border: 2px solid ${(props) => (props.selected ? colours.blue : colours.grey)};

  padding: 2em;
  border-radius: 10px;
  flex-direction: column;
  cursor: pointer;

  &:hover {
    border: 2px solid
      ${(props) => (props.selected ? colours.blue : colours.black)};
    background: "#f3f3f3";
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 1.4em;
  margin-bottom: 0.5em;
`;

export const CryptoOrStandard: React.FunctionComponent<{}> = () => {
  const { isCrypto, setIsCrypto } = useNewLaunchContext();
  return (
    <>
      <SectionTitle>Form Type</SectionTitle>
      <Grid col-xs={2}>
        <Container selected={!isCrypto} onClick={() => setIsCrypto(false)}>
          <StyledIcon type="aboutUs" />
          Standard
        </Container>
        <Tooltip title="This will enable fields like crypto chains, wallet verification, etc.">
          <Container selected={isCrypto} onClick={() => setIsCrypto(true)}>
            <StyledIcon type="aboutUs" />
            Crypto
          </Container>
        </Tooltip>
      </Grid>
    </>
  );
};
